var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217 151.3",
    style: {
      enableBackground: "new 0 0 217 151.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207,151.3H10c-5.5,0-10-4.5-10-10s4.5-10,10-10h197c5.5,0,10,4.5,10,10S212.5,151.3,207,151.3z M207,85.7H10 c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10h197c5.5,0,10,4.5,10,10C217,81.2,212.5,85.7,207,85.7z M207,20H10C4.5,20,0,15.5,0,10 S4.5,0,10,0h197c5.5,0,10,4.5,10,10S212.5,20,207,20z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerDark);
export default __webpack_public_path__ + "static/media/hamburger-dark.8e921db259bb3c7f50b9e186cbc7719a.svg";
export { ForwardRef as ReactComponent };